import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Form, Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { fetchEditCategory } from '../../../../redux/action/category/editCategory';
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie';
import MainLoading from '../../../../utils/MainLoading';

const EditModal = (props) => {
    const [loading, setLoading] = useState(false)
    const [name , setName] = useState('')
    const dispatch = useDispatch()
    const {t} = useTranslation();

    const handleEditCategory = (e) => {
        setName(e.target.value)
    }

    useEffect(() => {
        setLoading(true)
        axios.get(`p/category/${props.id}`)
        .then(res => {
            setLoading(false)
            setName(res.data.name)
        })
        .catch(err => console.log(err))
    }, [props.id])

    const editCategory = (e) => {
        e.preventDefault()
        dispatch(fetchCsrfCookie())
        dispatch(fetchEditCategory(props.id, name))
        props.update()
    }

    return (
        <>
            {props.show && (
                <Modal show={props.show}>
                    <Modal.Header>
                        <Modal.Title>{t("edit")}</Modal.Title>
                    </Modal.Header>
                        <Form onSubmit={e => editCategory(e)}>
                        <ModalBody>
                            {loading ?
                                <MainLoading />
                            :
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>{t("title")} </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name" 
                                    value={name}
                                    onChange={(e) => handleEditCategory(e)} 
                                />
                            </Form.Group>
                            }
                            
                        </ModalBody>
                        <ModalFooter>
                            <button className='btn btn-secondary col-md-3 mr-3 offset-md-5' type="button" onClick={props.handleClick}>
                                {t("Cancel")}
                            </button>
                            <button className='btn green-btn mx-1 col-md-3' type="submit">
                                {t("submit")}
                            </button>
                        </ModalFooter>
                    </Form>
                </Modal>
            )}
        </>
    )
}

export default EditModal
